/**
 * Tramino API Benchmark
 */

var template = require('./template.html');
var StyleTemplate = require('./style.html');

var Backbone = require('backbone');
var BenchmarkModel = Backbone.Model.extend({});


var BenchmarkView = Backbone.View.extend({

	id: 'api-benchmark',
	className: 'timebar hidden',

	events: {
		'click h1': 'toggle',
		'mouseenter h1': 'show',
		'mouseleave': 'hide',
		'mouseenter div[data-index]': 'hover',
		'mouseleave div[data-index]': 'unhover',
	},

	render: function() {
		this.el.innerHTML = template(this.model.attributes);
	},

	show: function(e) {
		this.$el.removeClass('hidden');
	},

	hide: function(e) {
		this.$el.addClass('hidden');
	},

	toggle: function(e) {
		this.$el.toggleClass('fixed');
	},

	hover: function(e) {
		var index = $(e.currentTarget).data('index');
		this.$el.find('div[data-index=' + index + ']').addClass('hovered');
	},

	unhover: function(e) {
		this.$el.find('.hovered').removeClass('hovered');
	},
});


var process = function(benchmark) {
	var results = benchmark.results;

	var data = {
		min: 0.0,
		max: 0.0,
		total: 0.0,
		results: [],
		extra: benchmark.extra,
	};

	for (var i = 0, result; result = results[i]; ++i) {
		if ( data.min > result.start ) data.min = result.start;
		if ( data.max < result.end ) data.max = result.end;
		result.duration = result.end - result.start;
	}
	data.total = data.max - data.min;

	for (var i = 0, result; result = results[i]; ++i) {
		result.startPercent = result.start / data.total * 100;
		result.endPercent = result.end / data.total * 100;
		result.left = result.startPercent + '%';
		result.width = (result.endPercent - result.startPercent) + '%';
		result.color = (i % 20) + 1;

		data.results.push(result);
	}

	return new BenchmarkModel(data);
};

var view;
var initialized = false;

module.exports = {
	init: function() {
		if ( initialized ) return;
		$('body').append(StyleTemplate());

		view = new BenchmarkView({
			model: new BenchmarkModel(),
		});

		$('body').append(view.el);
		initialized = true;
	},
	render: function(benchmark) {
		if ( !initialized ) throw new Error("ApiBench is not initialized");

		view.model = process(benchmark);
		view.render();
	},
	process: process,
};



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/apibench/index.js
 **/